import { Alert, Box, Heading, Input, Text } from "@twilio-paste/core";
import React, { useState } from "react";
import * as Icons from "../../assets/icons/doc-icons";
import IconTile from "./IconTile";

function IconsList() {
    const allIconsKeys = Object.keys(Icons);
    const [iconsKeys, setIconKeys] = useState(Object.keys(Icons));
    return (
        <>
            <Heading as="h2" variant="heading10">
                Available Icons
            </Heading>
            <Alert variant="neutral">
                <Text as="span">
                    <strong>Icon names are case-sensitive</strong>
                </Text>
            </Alert>
            <Box marginY="space80" paddingX="space10">
                <Input
                    placeholder="Filter by name"
                    data-testid="icons-search-input"
                    onChange={(e) => {
                        setIconKeys(
                            allIconsKeys.filter((iconKey: string) =>
                                iconKey.toLowerCase().substring(3).includes(e.currentTarget.value?.toLowerCase())
                            )
                        );
                    }}
                    type="text"
                />
            </Box>
            <Box
                display="grid"
                gridTemplateColumns={[
                    "repeat(auto-fill, min(130px,100%))",
                    "repeat(auto-fill, min(130px,100%))",
                    "repeat(auto-fill, min(200px,100%))"
                ]}
                rowGap="space50"
                columnGap="space50"
                justifyContent={["space-around", "space-around", "space-between"]}
                maxWidth="100%"
                list-style="none"
                paddingX="space0" // li has a padding by default
                as="ul"
                data-testid="search-results"
            >
                {iconsKeys.map((name: string) => {
                    const iconDisplayName = name.substring(3);
                    const currentIcon: keyof Object = `Icn${iconDisplayName}` as keyof Object;
                    const Icon: React.FC<React.SVGProps<SVGSVGElement>> = Icons[currentIcon] as React.FC<
                        React.SVGProps<SVGSVGElement>
                    >;
                    return (
                        <IconTile
                            key={iconDisplayName}
                            iconDisplayName={iconDisplayName}
                            Icon={<Icon width="2rem" height="2rem" />}
                        />
                    );
                })}
                {iconsKeys.length === 0 && (
                    <Text as="p" data-testid="no-result">
                        No Icons Found
                    </Text>
                )}
            </Box>
        </>
    );
}

export default IconsList;
